import db from "../dexie-db/db";
import { SyncStatus } from "./types";
const qnaNodeUserCreating = (primKey, obj) => {
    if (!('_status' in obj)) {
        obj._status = SyncStatus.PENDING_PUSH;
    }
};
const qnaNodeUserUpdating = (modifications, primKey, obj) => {
    if (!Object.prototype.hasOwnProperty.call(modifications, '_status')) {
        return {
            _status: SyncStatus.PENDING_PUSH,
        };
    }
};
// Add event listeners to automatically update status to PENDING_PUSH on create/update
const dbListeners = {
    init() {
        db.qnaNodeUser.hook('creating', qnaNodeUserCreating);
        db.qnaNodeUser.hook('updating', qnaNodeUserUpdating);
    },
    destroy() {
        db.qnaNodeUser.hook('creating').unsubscribe(qnaNodeUserCreating);
        db.qnaNodeUser.hook('updating').unsubscribe(qnaNodeUserUpdating);
    },
};
export default dbListeners;
